import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FiBell, FiChevronRight } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import Typography from '../components/Typography'
import Sidebar from '../Sidebar'
import { NotificationBadge } from '../../Menu/Notifications/Components'
import { default as NotificationsList } from '../../../../Notifications'
import {
  getNotificationsCount,
  getNotificationsNotReadCount,
} from '../../../../../reducers/userAccount/selectors/notifications/getNotificationsCounts'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function NotificationsMenu() {
  const [open, setOpen] = React.useState<boolean>()
  const { t } = useTranslation()
  const taskCount = useSelector(getNotificationsNotReadCount)
  const notifications = useSelector(getNotificationsCount)
  const notificationCount = useSelector(getNotificationsNotReadCount)
  const userId = useSelector(getUserId)
  function toggleOpen() {
    if (!open) {
      Mixpanel.track('Notifications Menu Item Used', {
        'Number Of Notifications': Number(notificationCount),
      })
      Mixpanel.people.increment(userId, 'Notifications Menu Opened', 1)
    }
    if (notifications || open) {
      setOpen(!open)
    }
  }

  function stopPropagation(e) {
    e.stopPropagation()
  }

  return (
    <ListItem style={{ minHeight: '60px' }} button={true} onClick={toggleOpen}>
      <ListItemIcon style={{ minWidth: '30px', width: '30px' }}>
        <>
          <FiBell size={20} style={{ minHeight: 20, minWidth: 20 }} />
          <div style={{ left: '-15px', position: 'relative', top: '-10px' }}>
            <NotificationBadge
              taskCount={taskCount ? String(taskCount) : '0'}
            />
          </div>
        </>
      </ListItemIcon>
      <ListItemText
        primary={<Typography>{t('room_notification_title')}</Typography>}
      />
      <FiChevronRight />
      <Sidebar
        closeDrawer={toggleOpen}
        open={open}
        elevation={0}
        headerIcon={
          <>
            <FiBell size={20} style={{ minHeight: 20, minWidth: 20 }} />
            <div style={{ left: '-15px', position: 'relative', top: '-10px' }}>
              <NotificationBadge
                taskCount={taskCount ? String(taskCount) : '0'}
              />
            </div>
          </>
        }
        headerLabel={t('room_notification_title')}
      >
        <div onClick={stopPropagation}>
          <NotificationsList
            height={'calc(var(--full) - 55px)'}
            minHeight={'calc(var(--full) - 105px)'}
            withoutHeader={true}
          />
        </div>
      </Sidebar>
    </ListItem>
  )
}

export default NotificationsMenu
